var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoPortfolio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 115,
    viewBox: "0 0 112 115",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2218_7353)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.1772 40.0892L84.2907 48.221L102.675 56.9718L111.996 32.2515L84.0268 16.1227L56.0575 0L28.0943 16.1227L0.125 32.2515L15.969 55.066L41.944 40.0892L56.0575 31.9513L70.1772 40.0892Z",
    fill: "#6A5391"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.9478 88.9108L0 64.7236L0.128863 96.7484L28.0982 112.871L56.0614 128.994L84.0307 112.871L56.0614 97.0487L41.9478 88.9108Z",
    fill: "#D2AE2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.2937 80.7713L111.999 64.8018V64.5015V32.25L84.2937 48.2195L56.0605 64.5015V97.0533L84.2937 80.7713Z",
    fill: "#8E64A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8305 64.5015V48.2195L0.125 32.25V64.5015V96.7531L27.8305 80.7713V64.5015Z",
    fill: "#C59535"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2218_7353"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 112,
    height: 129,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoPortfolio);
export default __webpack_public_path__ + "static/media/logo_portfolio.39a5fbf827a509f47d3708034ad7e8b2.svg";
export { ForwardRef as ReactComponent };